import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { NitroNavBar, NitroButton,} from 'nitro-components';

import { SelectField, MenuItem } from 'material-ui';
import { NitroTextField } from 'nitro-components/build/nitro';
import AdminAPI from '@src/api/AdminApi';
import UserApi from '@src/api/UserApi';
import * as Routes from '@src/routes/const';
import PropTypes from 'prop-types';
import { notify, closeNotify } from '@src/components/libs/notification';

export const MainBody = styled.div`
  padding: 20px 60px;

  display: flex;
  flex-direction: column;
`;
export const UserSection = styled.div`
  width: 45%;
  display: flex;
  flex-direction: column;
`;

const Container = styled.div`
  margin-top: 0px;
  margin-bottom: 50px;
  transition: opacity 2s;

  .fileclass {
    display: none;
  }
`;
const ContainerItem = styled.div`
  float: left;
  margin-top: 10px;
  transition: opacity 2s;
  line-height: 16px;
  margin-right: 30px;
  .containerItemLink {
    margin-top: 20px !important;
  }
`;

class UserBulkImport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      FileList: {},
      selectedFile: '',
      bizEntityDataSource: [],
      businessEntityId: '',
      selectedEntity: '',
      selectedEntityKey: '',
      selectedCountryCode: '',
      RolesDataSource: [],
      SelectedRole: '',
      errormessage: false,
      timezones: [],
      timeZoneName: '',
      timeZone: {},
    };
    this.handleChange = this.handleChange.bind(this);
    this.onFieldChange = this.onFieldChange.bind(this);
    this.onRoleChange = this.onRoleChange.bind(this);
  }

  async componentWillMount() {
    const bizEntOpts = await this.getBizEntities();
    console.log({ bizEntOpts });
    this.setState({ bizEntityDataSource: bizEntOpts });
  }
  onFieldChange = (event, index, key) => {
    const obj = this.state.bizEntityDataSource.filter(e => {
      if (e.EntityKey === key) return true;
    });
    this.setState({
      businessEntityId: obj[0].Id,
      selectedEntity: obj[0].EntityKey,
      selectedEntityKey: key,
      selectedCountryCode: obj[0].CountryCode,
      timeZoneName: '',
      SelectedRole: '',
    });
    const businessRoles = this.getRolesByBusinessEntity(
      obj[0].Id,
      obj[0].CountryCode
    );
    this.getTimzeZones(obj[0].CountryCode);
  };
  getBizEntities = () =>
    AdminAPI.getBusinessEntities()
      .then(data => data)
      .catch(err => err);

  getRolesByBusinessEntity = (id, countryCode) =>
    AdminAPI.getAllRoles(id, countryCode)
      .then(data => {
        this.setState({ RolesDataSource: data });
        return data;
      })
      .catch(err => err);

 

  triggerInputFile = () => this.fileInput.click();

 

  onRoleChange = (event, index, value) => {
    this.setState({ SelectedRole: value });
  };

  onSubmitClick = () => {
    const bulkFileUpload = {
      countryCode: this.state.selectedCountryCode,
      businessEntityId: this.state.businessEntityId,
      roleId: this.state.SelectedRole,
      zoneId: this.state.timeZone.zoneId,
      File: this.state.FileList,
    };

    this.SaveFileUpload(bulkFileUpload)
      .then(data => {
         const { notify } = this.props;
        const datamsg= data && data.success ? data : data.response.data;
        const errMsg = !datamsg.success
          ? datamsg.errors[0].errorMessage
          :  'User import process has been initiated. You will be notified about the progress through email.';
         notify({ title:errMsg});
         this.clearSnackbarError();
      })
      .catch(err => {
          console.log('error saving file');
          console.log({err});
        
      });
  };

  handleClickAway = () => {
    AdminAPI.getSampleFile().then(response => response);
  };

  clearSnackbarError = () => {
    this.setState({
      errormessage: undefined,
      selectedFile: '',
      selectedEntity: '',
      SelectedRole: '',
    });
  };

  setTimeZone = timezones => {
    this.setState({
      timezones,
    });
  };

  getTimzeZones = countryCode => {
    if (countryCode)
      UserApi.getTimeZones(countryCode)
        .then(data => {
          this.setTimeZone(data);
        })
        .catch(err => err);
  };

  handleChange(selectorFiles: FileList) {
    const file = selectorFiles[0];
    console.log(file.name);
    const regEx = new RegExp('([a-zA-Z0-9s_\\.-:])+(.csv)$');
    if (!regEx.test(file.name)) {
      return;
    }
    this.setState({ FileList: selectorFiles, selectedFile: file.name });
  }
  SaveFileUpload = bulkFileUpload =>
    AdminAPI.saveBulkUserData(bulkFileUpload)
      .then(data => data)
      .catch(err => err);

  goBack = () => {
    const { router } = this.context;
    router.push(Routes.INSIGHTS);
  };
  extractBizEntity = selkey => {
    const { bizEntityDataSource } = this.state;
    const bizEnt = bizEntityDataSource.find(x => x.EntityKey === selkey);
    return bizEnt;
  };

  extractTimeZone = zoneName => {
    const { timezones } = this.state;
    const timezone = timezones.find(z => z.zoneName === zoneName);
    return timezone;
  };

  onTimeZoneChange = (name, value) => {
    this.setState({
      [name]: value,
    });
  };

  render() {
    const disabled =
      this.state.selectedEntity.length === 0 ||
      this.state.selectedFile.length === 0 ||
      this.state.SelectedRole.length === 0 ||
      this.state.timeZoneName.length === 0;

    return (
      <MainBody>
        
        <NitroNavBar
          label="Import users"
          header
          variant="secondary"
          action={this.goBack}
        />
        <Container>
          <ContainerItem className="containerItemLink">
            <a href="#" onClick={this.handleClickAway}>
              Download sample csv file.
            </a>
          </ContainerItem>
        </Container>
        <Container>
          <ContainerItem>
            <NitroTextField
              placeholder="Select csv file"
              value={this.state.selectedFile}
            />
          </ContainerItem>
          <ContainerItem>
            <input
              type="file"
              ref={fileInput => (this.fileInput = fileInput)}
              onChange={e => this.handleChange(e.target.files)}
              accept=".csv"
              className="fileclass"
            />
            <NitroButton
              label="Browse"
              size="small"
              variant="primary"
              action={this.triggerInputFile}
            />
          </ContainerItem>
        </Container>
        <Container>
          <SelectField
            floatingLabelText="Business Entity"
            value={this.state.selectedEntity}
            onChange={this.onFieldChange}>
            {this.state.bizEntityDataSource &&
              this.state.bizEntityDataSource.map((ea, idx) => (
                <MenuItem
                  key={idx}
                  value={ea.EntityKey}
                  primaryText={`${ea.Name} - ${ea.CountryCode.toUpperCase()}`}
                />
              ))}
          </SelectField>
        </Container>
        <Container>
          <SelectField
            floatingLabelText="Time Zones"
            disabled={!this.state.selectedEntity}
            value={this.state.timeZoneName}
            floatingLabelStyle={{
              color: '#0000004d',
            }}
            selectedMenuItemStyle={{
              color: '#bbbbbb',
            }}
            underlineStyle={{
              borderBottomColor: '#0000004d',
            }}
            onChange={(event, key, payload) => {
              this.onTimeZoneChange('timeZoneName', payload);
              const zone = this.extractTimeZone(payload);
              this.onTimeZoneChange('timeZone', zone);
            }}>
            {this.state.timezones.length > 0 &&
              this.state.timezones.map((ea, idx) => {
                const gmtOffset = ea.gmtOffset / 3600;
                let text = '';
                if (gmtOffset > 0) {
                  text = `(GMT + ${gmtOffset}) ${ea.zoneName}`;
                } else {
                  text = `(GMT - ${gmtOffset}) ${ea.zoneName}`;
                }
                return (
                  <MenuItem
                      key={`timeZone${idx}`}
                      value={ea.zoneName}
                      primaryText={text}
                  />
                );
              })}
          </SelectField>
        </Container>
        <Container>
          <SelectField
            floatingLabelText="User role"
            value={this.state.SelectedRole}
            onChange={this.onRoleChange}>
            {this.state.RolesDataSource &&
              this.state.RolesDataSource.map((e, idx) => (
                <MenuItem
                  key={idx}
                  value={e.id}
                  primaryText={`${e.description}`}
                />
              ))}
          </SelectField>
        </Container>
        <Container>
          <NitroButton
            label="Submit"
            size="small"
            variant="primary"
            disabled={disabled}
            action={this.onSubmitClick}
          />
        </Container>
      </MainBody>
    );
  }
}

UserBulkImport.contextTypes = {
  router: PropTypes.object,
  location: PropTypes.object,
};
const mapDispatchToProps = dispatch => ({
  notify: bindActionCreators(notify, dispatch),
  closeNotify: bindActionCreators(closeNotify, dispatch),
});

export default connect(
  null,
  mapDispatchToProps
)(UserBulkImport);

// export default UserBulkImport;



// WEBPACK FOOTER //
// ./src/features/admin/components/UserBulkImport.js